/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const user_feedback_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m.75 12 5.31.542c.579.06 1.13.288 1.59.658l4.21 3.406c.525.407.85 1.036.885 1.717a1.486 1.486 0 0 1-.854 1.482 2.152 2.152 0 0 1-2.125-.19L7.038 17.83m5.506 1.632h7.24c.95-.013 2.544.537 2.544 2.148l-11.902 1.382a3.164 3.164 0 0 1-1.515-.274L.751 19M12.696 4.716h7.933m-7.933 2.645h6.17m3.526 3.966h-5.18l-3.526 2.645v-2.645h-2.753a.881.881 0 0 1-.881-.881V1.63c0-.486.395-.881.881-.881h11.46a.88.88 0 0 1 .88.881v8.815a.881.881 0 0 1-.88.881Z"
    />
  </svg>
)
export default user_feedback_medium
